import React from 'react';
import { ImageProps } from '.';

const SvgStoreZigzinBadge = ({ size = 111, ...props }: ImageProps): JSX.Element => {
  return (
    <svg width={size} height={(size && Math.floor(size / 3.46875)) || 32} fill='none' viewBox='0 0 111 32' {...props}>
      <g clipPath='url(#StoreZigzinBadge_svg__a)'>
        <path
          fill='#216BFF'
          d='M0 16C0 7.163 7.135 0 15.936 0h79.128C103.865 0 111 7.163 111 16s-7.135 16-15.936 16H15.936C7.135 32 0 24.837 0 16Z'
        />
        <path
          fill='#fff'
          fillRule='evenodd'
          d='M71.96 23.569h-2.028v-7.775h-2.528c-.217 2.828-1.723 4.558-3.767 4.558-2.221 0-3.815-2.02-3.8-5.253-.015-3.2 1.579-5.237 3.8-5.237 1.98 0 3.454 1.641 3.751 4.284h2.544V8.828h2.028v14.74ZM63.637 11.72c-1.094 0-1.851 1.196-1.835 3.378-.016 2.198.74 3.378 1.835 3.378 1.11 0 1.835-1.18 1.835-3.378 0-2.182-.724-3.378-1.835-3.378Z'
          clipRule='evenodd'
        />
        <path
          fill='#fff'
          d='M85.78 23.537h-2.06V19.98h-8.017v-1.65H85.78v5.206ZM91.955 21.63h8.13v1.648H89.878V18.51h2.077v3.12ZM19.777 9.361c4.25-.067 7.698 2.627 7.698 6.622l-.01.368c-.207 3.79-3.57 6.316-7.688 6.25-.788-.013-1.394-.11-2.249-.348-2.68-.75-7.953-3.951-9.746-5.284-.182-.135-.063-.407.166-.385l10.793 1.039c.165.016.26.183.18.32l-1.039 1.788c-.115.197.126.407.328.287l6.277-3.763a.316.316 0 0 0 0-.548l-6.277-3.762c-.202-.12-.443.09-.328.288l1.04 1.787c.077.137-.017.303-.181.32L7.948 15.38c-.23.021-.346-.251-.166-.385 1.792-1.333 7.066-4.537 9.746-5.287.855-.238 1.461-.335 2.249-.347ZM57.511 11.495H49.35v1.47h7.824v1.617h-7.824v1.535h8.275v1.633h-4.218v2.49h5.683v1.648h-13.41v-1.649h5.65V17.75h-4.073V9.846h10.255v1.649ZM45.17 21.726H31.76V20.03h13.41v1.697ZM99.698 19.48h-2.06V8.844h2.06V19.48ZM96.092 11.527h-2.946v.21c0 1.762 1.08 3.556 3.494 4.283l-1.047 1.617c-1.641-.518-2.8-1.576-3.46-2.91-.669 1.447-1.86 2.61-3.575 3.185l-1.062-1.617c2.43-.792 3.557-2.7 3.558-4.558v-.21h-3.011V9.878h8.05v1.649ZM85.78 17.685h-2.06V8.828h2.06v8.857ZM39.472 10.767c0 2.15 1.9 4.461 5.216 5.027l-.902 1.713c-2.551-.509-4.451-1.947-5.393-3.847-.974 1.883-2.874 3.33-5.409 3.848l-.885-1.714c3.251-.582 5.167-2.893 5.184-5.027V9.7h2.189v1.067ZM82.174 11.333h-2.946c.017 1.721 1.096 3.532 3.494 4.251l-1.047 1.6c-1.641-.509-2.8-1.568-3.46-2.91-.669 1.455-1.86 2.611-3.575 3.185l-1.062-1.6c2.414-.784 3.541-2.692 3.557-4.526h-3.01V9.684h8.05v1.649Z'
        />
      </g>
      <defs>
        <clipPath id='StoreZigzinBadge_svg__a'>
          <path fill='#fff' d='M0 0h111v32H0z' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgStoreZigzinBadge;
